import { Variant } from "@/types/types";

export const getBundleServices = (variant: Variant) => {
  const bundleVariant = variant?.components?.[0]?.variant as Variant;
  return bundleVariant?.services?.length ? bundleVariant.services : [];
};
